import { useHistory } from "react-router-dom";
import NestedSideNavigationProps from "../../services/models/nestedSideNavigationProps.model";
import CustomNavLink from "../atomic/CustomNavLink";

function NestedSideNavigation({
  links,
}: Readonly<NestedSideNavigationProps>): JSX.Element {
  const history = useHistory()
  const isNotificationPage = history?.location?.pathname?.includes("notifications")
  return (
    <nav className={`flex justify-between items-center md:block bg-white border-b md:border-b-0 md:bg-sideNavGray border-r overflow-auto md:px-5 ${isNotificationPage ? 'px-0.5' : 'px-3'} xs:-mt-4 md:mt-0 md:py-2`}>
      {links.map((link) => (
        <CustomNavLink key={link.name} {...link} />
      ))}
    </nav>
  );
}

export default NestedSideNavigation;
